import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import AnalystGlyph from "./AnalystGlyph";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Sits in header row 1, beside the search field (header redesign, 2-Nov-2026).
// Depth rule: colour + lift = "where you are". At rest the online pill's
// tinted frosted glass in orange (same as the magic search button); on
// /analyst solid orange and lifted. Never grey and pressed in (pressed in only
// ever means "this button's menu is open").
export default function AnalystButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let live = true;
    axios.get(`${API}/ai/status`).then(({ data }) => live && setEnabled(!!data?.enabled_for_me)).catch(() => {});
    return () => { live = false; };
  }, []);

  if (!enabled) return null;
  const active = pathname === "/analyst";
  return (
    <button
      type="button"
      onClick={() => navigate("/analyst")}
      data-testid="analyst-btn"
      title="Analyst — answers worked out from your RockLink data"
      aria-current={active ? "page" : undefined}
      className={`rl-analyst-btn rl-frost-tint rl-tint-orange rl-orange-glass relative inline-flex items-center gap-1.5 h-8 px-3.5 rounded-full shrink-0 whitespace-nowrap ${active ? "on" : ""}`}
    >
      <AnalystGlyph size={13} />
      <span className="text-[12.5px] font-semibold leading-none"
        style={{ fontFamily: "var(--rl-font-heading), sans-serif", letterSpacing: "var(--rl-heading-tracking)" }}>
        Analyst
      </span>
    </button>
  );
}
